<template>
  <main class="page-sidebar page-padding page-things">
    <thing-list></thing-list>
    <p class="btn-hint name-hint btn-hint_bottom btn-hint-navigator">

    </p>
  </main>
</template>

<script>
  import { mapMutations, mapActions} from 'vuex'
  import {tokenAndRoute} from "../../mixins/utils/tokenAndRoute";
  import thingIcon from '../../components/Svg/things/thing'
  import {generateGrid} from "../../mixins/generateGrid";
  import thingList from '../../components/Pages/Things/Things/thingsList'
  import {loaderMixin} from "../../mixins/utils/loaderMixin";
  import {pageSettings} from "../../mixins/utils/pageSettings";

  export default {
    name: 'things',
    mixins: [tokenAndRoute, generateGrid, loaderMixin, pageSettings],
    components: {
      thingIcon,
      thingList
    },
    watch: {
      route(val) {
        this.setChecked([]);
        if (val.name === 'things') {
          let nodes = document.querySelectorAll('.vtl-node-main');
          nodes.forEach(item => {
            item.classList.remove('active-icon_node')
          });
          document.title = `OmniioTh | Вещи`
          this.setFullSidebar(true);
          this.setLinkName('');
        }
      }
    },
    data() {
      return {

      }
    },
    computed: {
      route() {
        return this.$route
      }
    },
    methods: {
      ...mapMutations({
        setChecked: 'things/SET_CHECKED_THINGS_LIST',
        setLinkName: 'sidebar/SET_LINK_NAME',
      }),
      ...mapActions({
        getOwnedDevices: 'things/getDevices',
        // getAssignedDevices: 'things/getAssignedDevices',
      })
    },
    mounted() {
      this.getOwnedDevices()
    },
    beforeRouteEnter(to, from, next) {
      next(async vm => {
        const token = localStorage.getItem('token');

        if (vm.$route.name !== 'thing' && vm.$route.name !== 'virtualThingList') {
          vm.setFullSidebar(true);
        } else {
          vm.setFullSidebar(false);
        }
        vm.setRouteName('');
        vm.setLinkName('things');

        vm.showLoader();
        await vm.getUsers(token);
        await vm.getInvitedUsers(token);
        await vm.getRoles({token, id: ''});
        await vm.getOwnedDevices();
        // await vm.getAssignedDevices({token});
        // vm.setFullSidebar(true);
        // vm.setLinkName('');
        /*await vm.getAssignedDevices({token});*/
        vm.hideLoader();

        //vm.getThings({token, id: ''})
      })
    }
  }
</script>

<style lang="scss" scoped>
.page-things {
  padding-top: 90px;
  padding-bottom: 50px;
  padding-right: 50px;
}

.btn-hint-navigator {
  position: absolute;
  z-index: 9;
  width: auto;
  opacity: 1;

  &::before {
    left: 20px;
  }
}
</style>
